module.exports = "pegasus_template/assets/hexagon-instagram.png";